import { useStore } from '@store/index';
import { normalizeEmail } from '@utils/validation';
import { useMemo } from 'react';

/**
 * Returns true when the current user's email is in the AI Chat allowlist
 * configured via the REACT_APP_AI_CHAT_ALLOWED_EMAILS env var
 * (comma-separated list of emails).
 */
export const useIsAiChatAllowedEmail = (): boolean => {
  const { user } = useStore();

  return useMemo(() => {
    if (!user?.email) return false;

    const raw = process.env.REACT_APP_AI_CHAT_ALLOWED_EMAILS;
    if (!raw) return false;

    const allowed = raw
      .split(',')
      .map(entry => normalizeEmail(entry))
      .filter(Boolean);

    if (allowed.length === 0) return false;

    return allowed.includes(normalizeEmail(user.email));
  }, [user?.email]);
};
